module.exports = __webpack_public_path__ + "static/img/stamp_reject.364a3360.svg";